import styled from 'styled-components';
import { colors, media } from '../../../core';
import Icon from '../Icon';
import Text from '../Text';

export const Container = styled.div`
  background-color: ${colors.pearl};
  width: 1200px;
  margin: 0 auto;
  padding: 54px 16px 0;

  ${media.large} {
    width: 100%;
  }
`;

export const Timezone = styled(Text)`
  margin-bottom: 54px;
`;

export const Nav = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 28px;
`;

export const NavButton = styled.button.attrs({ type: 'button' })`
  -webkit-appearance: none;
  background: none;
  border: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:disabled,
  &[disabled] {
    cursor: default;
    opacity: 0.5;
  }
`;

export const IconLeft = styled(Icon)`
  margin-right: 4px;
`;

export const IconRight = styled(Icon)`
  margin-left: 4px;
`;

export const Row = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(7, 14.3%);
  row-gap: 20px;
  padding: 54px 0;

  ${media.xsmall} {
    grid-template-columns: 1fr;
    row-gap: 0;
  }
`;

export const Column = styled.div`
  border-right: 1px solid ${colors.cloud};
  display: flex;
  flex-direction: column;
  align-items: center;

  &:nth-child(7n + 7) {
    border-right: 0;
  }

  ${media.xsmall} {
    border-right: 0;
  }
`;

export const ColumnTitle = styled(Text)`
  margin-bottom: 34px;
  min-width: 90px;
  width: 80%;
  text-align: center;
  color: ${({ theme }) => theme.fontColor || colors.ash};

  ${media.small} {
    font-size: 14px;
  }
`;

export const SlotTime = styled.button.attrs({ type: 'button' }) <{
  isSelected: boolean;
}>`
  -webkit-appearance: none;
  background-color: ${({ isSelected }) => (isSelected ? colors.lightblue : colors.white)};
  border: ${({ isSelected }) =>
    isSelected ? `2px solid ${colors.darkblue}` : `1px solid ${colors.strokeblue}`};
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  color: ${({ theme }) => theme.fontColor || colors.ash};
  font-family: ${({ theme }) => theme.fontFamily || 'Quicksand, sans-serif'};
  font-size: 16px;
  font-weight: ${({ theme }) => theme.buttonFontWeight || 600};
  line-height: 20px;
  text-decoration: none;
  text-align: center;
  align-items: center;
  justify-content: center;
  min-width: 90px;
  width: 80%;
  height: 55px;
  margin-bottom: 16px;
  transition: background-color 0.3s;
  text-transform: uppercase;

  &:hover {
    background-color: ${colors.lightblue};
    transition: background-color 0.3s;
  }

  ${media.xsmall} {
    width: 100%;
    min-width: 100%;
  }
`;

export const ColumnHeader = styled.div``;

export const EmptySlots = styled.div`
  display: flex;
  padding: 0 24px;
  align-items: center;
  text-align: center;

  ${media.xsmall} {
    p {
      text-align: center;
      font-size: 14px;
    }
  }
`;
